module.exports = __webpack_public_path__ + "img/icon运动员等级_职工三级@3x.cb6ceefa.png";